export enum DefaultBlockTrigger {
    Instant = "Instant",
    ShowAfterMs = "ShowAfterMs",
    UserAction = "UserAction",
}